import type { ScenarioRunStep } from '../lib/api';
import type { Finding } from '../domain/types';

interface Props {
  steps: ScenarioRunStep[];
}

const SEVERITY_LABEL: Record<Finding['severity'], string> = {
  info: 'Información',
  warning: 'Advertencia',
  error: 'Error',
  critical: 'Crítico',
};

function FindingCard({ finding }: { finding: Finding }) {
  return (
    <li className={`finding finding--${finding.severity}`}>
      <div className="finding__header">
        <span className="finding__severity">{SEVERITY_LABEL[finding.severity]}</span>
        <span className="mono">{finding.ruleId}</span>
      </div>
      <p className="finding__message">{finding.message}</p>
      {finding.suggestion ? <p className="finding__suggestion">{finding.suggestion}</p> : null}
      {finding.evidencePath ? (
        <p className="finding__evidence mono">{finding.evidencePath}</p>
      ) : null}
    </li>
  );
}

export function Timeline({ steps }: Props) {
  if (steps.length === 0) {
    return (
      <p className="empty-state">
        Aún no hay resultado. Ejecuta el fixture para ver cada decisión.
      </p>
    );
  }
  return (
    <div>
      {steps.map((step, index) => (
        <div key={`${step.label}-${index}`}>
          <p className="timeline__attempt-label">{step.label}</p>
          <ul className="timeline" aria-label={`Línea temporal: ${step.label}`}>
            {step.output.findings.map((finding, findingIndex) => (
              <FindingCard key={`${finding.ruleId}-${findingIndex}`} finding={finding} />
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
